export default __webpack_public_path__ + "static/media/report.d3197fb2.png";